import React, { useCallback, useEffect, useMemo, useRef } from "react";
import Painting from "./Painting";
import * as THREE from "three";

const FramePreview = ({ layer, layerName, imageUrl }) => {
  const frameRef = useRef();

  const getFramePosition = useCallback(
    (startTile, endTile, layer, scale = false, isEastOrWest = false) => {
      const { row, column } = startTile;
      if (!endTile) return 0;
      else {
        let x = row > endTile.row ? endTile.row : row;
        let start = row < endTile.row ? endTile.row : row;

        let y = column < endTile.column ? column : endTile.column;
        let end = column > endTile.column ? column : endTile.column;
        const offset = startTile.column > endTile.column ? -1 : 1;
        const rowOffset = startTile.row > endTile.row ? -1 : 1;

        if (scale) {
          if (layer === "north" || layer === "south") return end / (y || 1) + 1;
          else return start / (x || 1) + 1;
        }
        if (layer === "north" || layer === "south") {
          return (Math.floor(end / (y || 1)) * offset) / 2;
        } else if ((layer === "east" || layer === "west") && isEastOrWest) {
          return (Math.floor(start / (x || 1)) * offset * rowOffset) / 2;

          // verifier les maths floor !!!!

          // else if (layer === "east" && isEastOrWest) {
          //   return ((start / (x || 1)) * offset * rowOffset) / 2;
          // } else if (layer === "west" && isEastOrWest) {
          //   return ((start / (x || 1)) * offset * rowOffset) / 2;
        } else return 0;
      }
    },
    []
  );

  const myScale = useMemo(() => {
    return getFramePosition(
      layer.startTile || { row: layer.row, column: layer.column },
      layer.endTile,
      layerName,
      true
    );
  }, [layer, layerName, getFramePosition]);

  const myPosition = useMemo(() => {
    return [
      layerName === "east"
        ? 0.4
        : layerName === "west"
        ? -0.4
        : getFramePosition(
            layer.startTile || { row: layer.row, column: layer.column },
            layer.endTile,
            layerName
          ),
      1.6,
      layerName === "north"
        ? -0.4
        : layerName === "south"
        ? 0.4
        : getFramePosition(
            layer.startTile || { row: layer.row, column: layer.column },
            layer.endTile,
            layerName,
            false,
            true
          ),
    ];
  }, [layer, layerName, getFramePosition]);

  useEffect(() => {
    if (frameRef.current && layer.endTile) {
      let sizeVector = new THREE.Vector3();
      let box3 = new THREE.Box3().setFromObject(frameRef.current, true);
      box3.getSize(sizeVector);
      frameRef.current.position.set(
        frameRef.current.position.x,
        sizeVector.y / 2 + 1.2, // match unity calculus
        frameRef.current.position.z
      );
    }
  }, [myPosition, layer]);

  const myRotation = useMemo(() => {
    return layerName === "south"
      ? Math.PI
      : layerName === "east"
      ? -Math.PI / 2
      : layerName === "west"
      ? Math.PI / 2
      : 0;
  }, [layerName]);

  return (
    <group
      position={myPosition}
      ref={frameRef}
      scale={
        !layer.hasOwnProperty("endTile")
          ? [1, 1, 1]
          : [myScale, myScale, myScale]
      }
      rotation-y={myRotation}
    >
      <Painting imgUrl={imageUrl} molding={layer.molding} />
    </group>
  );
};

export default FramePreview;
